var path = 'src/app/components/customer/common/help.template.html';
var html = "<div class=\"icon-question-sign help-icon\"></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;